import { imageEffectSamples } from "./image-effect-samples";
import { buildR2AssetsImageUrl } from "../lib/image-url-builder";

export const imageEffectExamples = {
	pixar: {
		href: "/photo-to-pixar",
		namespace: "imageToPixar",
		examples: imageEffectSamples.pixar.slice(0, 3),
		cases: ["socialMedia", "gifts", "content", "gaming", "business", "nft"],
	},
	anime: {
		href: "/photo-to-anime",
		namespace: "imageToAnime",
		examples: [
			imageEffectSamples.anime[2],
			imageEffectSamples.anime[5],
			imageEffectSamples.anime[1],
		],
		cases: ["socialMedia", "gifts", "content", "gaming", "business", "nft"],
	},
	cartoon: {
		href: "/photo-to-cartoon",
		namespace: "imageToCartoon",
		examples: [
			imageEffectSamples.cartoon[0],
			imageEffectSamples.cartoon[4],
			imageEffectSamples.cartoon[1],
		],
		cases: ["socialMedia", "gifts", "content", "gaming", "business", "nft"],
	},
	age: {
		href: "/age-filter",
		namespace: "ageFilter",
		examples: [
			{
				before: "/images/age-filter/man-portrait.webp",
				after: buildR2AssetsImageUrl(
					"age-filter/banana-2-1-2026-10-26/curiosity-after.webp?v=f202b9960e",
				),
				prompt: "Transform the person in the image as a 60 year old",
				descriptionKey: "features.ageUpOrDown.description",
			},
			{
				before: "/images/age-filter/woman-portrait-2.png",
				after: buildR2AssetsImageUrl(
					"age-filter/banana-2-1-2026-10-26/professional-after.webp?v=d93b8cd02c",
				),
				prompt: "Transform the person in the image as a 12 year old",
				descriptionKey:
					"features.seeYourselfDifferentStages.description",
			},
			{
				before: "/images/age-filter/woman-portrait-3.webp",
				after: buildR2AssetsImageUrl(
					"age-filter/banana-2-1-2026-10-26/entertainment-after.webp?v=960242b467",
				),
				prompt: "Transform the person in the image as a 40 year old",
				descriptionKey: "features.perfectForGenealogy.description",
			},
		],
		cases: [
			"curiosity",
			"professional",
			"entertainment",
			"family",
			"creative",
			"gifts",
		],
	},
	buzz: {
		href: "/ai-buzz-cut",
		namespace: "aiBuzzCut",
		examples: imageEffectSamples.buzz.slice(0, 2),
		cases: ["preview", "boldLook", "barber"],
	},
} as const;
export type StandaloneImageEffect = keyof typeof imageEffectExamples;

export const ageUseCaseExamples = [
	{
		key: "family",
		before: buildR2AssetsImageUrl(
			"age-filter/use-cases-2026-10-26/family-before.webp?v=b3cd4adbb6",
		),
		after: buildR2AssetsImageUrl(
			"age-filter/banana-2-1-2026-10-26/family-after.webp?v=883acf0197",
		),
	},
	{
		key: "creative",
		before: buildR2AssetsImageUrl(
			"age-filter/use-cases-2026-10-26/creative-before.webp?v=f403e33f68",
		),
		after: buildR2AssetsImageUrl(
			"age-filter/banana-2-1-2026-10-26/creative-after.webp?v=010d5c0be6",
		),
	},
	{
		key: "gifts",
		before: buildR2AssetsImageUrl(
			"age-filter/use-cases-2026-10-26/gifts-before.webp?v=b864197383",
		),
		after: buildR2AssetsImageUrl(
			"age-filter/banana-2-1-2026-10-26/gifts-after.webp?v=9f87ffedda",
		),
	},
] as const;

export const imageEffectUseCaseExamples = {
	pixar: imageEffectSamples.pixar,
	anime: imageEffectSamples.anime,
	cartoon: imageEffectSamples.cartoon,
	buzz: imageEffectSamples.buzz,
	age: [
		...imageEffectExamples.age.examples.map((example, index) => ({
			...example,
			key: imageEffectExamples.age.cases[index],
		})),
		...ageUseCaseExamples,
	],
};
